
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import type { Message } from "../types";

export async function sendAIRequest(
  messageForAI: string,
  preferredLanguage: string,
  imageDataUrl: string | null,
  voiceSettings: any
): Promise<string> {
  console.log("🤖 Envoi de la requête à l'IA...");

  const { data, error } = await supabase.functions.invoke('ai-medical-assistant', {
    body: {
      message: messageForAI,
      language: preferredLanguage,
      hasImage: !!imageDataUrl,
      analysisMode: imageDataUrl ? "medical" : "general",
      imageData: imageDataUrl,
      voiceSettings: {
        continuousMode: voiceSettings.continuousMode,
        autoVoiceResponse: voiceSettings.autoVoiceResponse,
        voiceOnlyMode: voiceSettings.voiceOnlyMode,
        useElevenLabs: voiceSettings.useElevenLabs
      }
    }
  });

  if (error) {
    console.error("❌ Erreur assistant IA:", error);
    toast.error("Erreur de communication avec l'assistant médical");
    throw error;
  }

  if (!data?.response) {
    console.error("❌ Aucune réponse de l'IA");
    toast.error("Aucune réponse reçue de l'assistant médical");
    throw new Error("No response from AI");
  }

  console.log("✅ Réponse IA reçue avec succès");
  return data.response;
}

export function createUserMessage(
  userInput: string,
  selectedImage: any,
  imageHandling: any
): Message {
  return {
    id: `user-${Date.now()}`,
    role: "user",
    content: userInput || "Image pour analyse médicale",
    timestamp: new Date(),
    imageUrl: selectedImage ? URL.createObjectURL(selectedImage) : undefined,
    audioUrl: undefined,
    analysisMode: selectedImage ? "medical" : "general"
  };
}

export function createAssistantMessage(response: string, hasImage: boolean): Message {
  return {
    id: `assistant-${Date.now()}`,
    role: "assistant",
    content: response,
    timestamp: new Date(),
    analysisMode: hasImage ? "medical" : "general"
  };
}

export function generateMessageForAI(
  userInput: string,
  selectedImage: any,
  preferredLanguage: string
): string {
  if (selectedImage && userInput) {
    return `${userInput}\n\nImage jointe pour analyse médicale approfondie.`;
  } else if (selectedImage && !userInput) {
    return preferredLanguage === 'ht' 
      ? "Tanpri analize foto medikal sa a ak ba m konsèy sou sa ou wè a."
      : preferredLanguage === 'en'
      ? "Please analyze this medical image and provide advice on what you see."
      : preferredLanguage === 'es'
      ? "Por favor analiza esta imagen médica y proporciona consejos sobre lo que ves."
      : "Veuillez analyser cette image médicale et donner des conseils sur ce que vous observez.";
  }
  return userInput;
}
